import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    ClaimCta,
    FeatureBlock,
    FeatureHeading,
    FeatureTerms,
    FeatureTextCol,
    FeatureVisualCol,
    FeatureVisualFrame,
    FeatureVisualImage,
    MidSection,
} from './MidnightMigrationScreen.style';
import bettingImage from './assets/bettingImage.png';
import casinoImage from './assets/casinoImage.png';
import { midnitePartnerUrls } from './midnitePartnerUrls';

export const MidnightMigrationFeatureSection = observer(
    'MidnightMigrationFeatureSection',
    (props: { reversed: boolean; variant: 'casino' | 'sports' }): JSX.Element => {
        const { reversed, variant } = props;
        const isCasino = variant === 'casino';

        return (
            <MidSection>
                <FeatureBlock reverse={reversed}>
                    <FeatureVisualCol>
                        <FeatureVisualFrame>
                            <FeatureVisualImage
                                alt={
                                    isCasino === true
                                        ? 'Casino welcome offer — promotional graphic'
                                        : 'Sports welcome offer — promotional graphic'
                                }
                                decoding='async'
                                loading={isCasino === true ? 'eager' : 'lazy'}
                                src={isCasino === true ? casinoImage : bettingImage}
                            />
                        </FeatureVisualFrame>
                    </FeatureVisualCol>
                    <FeatureTextCol>
                        <FeatureHeading>
                            {isCasino ? (
                                <I18n
                                    langKey='account.midnight-migration.casino-offer-title'
                                    defaultText='Bet £20, get 100 free spins'
                                />
                            ) : (
                                <I18n
                                    langKey='account.midnight-migration.sports-offer-title'
                                    defaultText='Bet £10, get £30 in free bets'
                                />
                            )}
                        </FeatureHeading>
                        <FeatureTerms>
                            {isCasino ? (
                                <I18n
                                    langKey='account.midnight-migration.casino-offer-terms'
                                    defaultText='18+ New customers only. Wager £20 or more on Midnite Casino within 14 days of sign-up. Get 100 Free Spins to use on selected games, valued at 10p and valid for 7 days. T&Cs apply. BeGambleAware.org'
                                />
                            ) : (
                                <I18n
                                    langKey='account.midnight-migration.sports-offer-terms'
                                    defaultText='18+ New customers only. Place a £10+ bet at min odds 1/1 (2.0) within 14 days of sign-up. Get £30 in Free Bets, valid for 7 days on selected bets only. Free stake not returned with winnings. T&Cs apply. BeGambleAware.org'
                                />
                            )}
                        </FeatureTerms>
                        <ClaimCta
                            dataTest={isCasino ? 'midnight-migration-claim-casino' : 'midnight-migration-claim-sports'}
                            to={isCasino ? midnitePartnerUrls.casinoOffer : midnitePartnerUrls.sportsOffer}
                        >
                            <I18n
                                langKey='account.midnight-migration.cta-claim-bonus'
                                defaultText='Claim bonus'
                            />
                        </ClaimCta>
                    </FeatureTextCol>
                </FeatureBlock>
            </MidSection>
        );
    }
);
